import { html, SYSBaseElement } from "../../../src"
import { DialogOk } from "../../../src/library/dialog/dialogapi"
import { T } from "../../../src/textapi"

export class ScreenSYSLandinfPage01 extends SYSBaseElement {
  pwReset: {
    timestamp: Date
    token: string
  }
  async init() {
    const urlParams = new URLSearchParams(this.state.ovl.app.urlQueryString)
    let pwReset = urlParams.get("ovlpwreset")
    if (pwReset) {
      let timestamp = pwReset.split("_")[1]
      this.pwReset = { timestamp: new Date(timestamp), token: pwReset }
      this.pwReset.token = pwReset
      const twoHoursInMs = 2 * 60 * 60 * 1000
      const twoHoursAgo = Date.now() - twoHoursInMs

      // Check if the timestamp is older than two hours
      if (this.pwReset.timestamp.getTime() < twoHoursAgo) {
        await DialogOk(T("SYSLandingPage01PasswordResetTokenExpired"))
        location.reload()
        return true
      }
    }
  }
  async getUI() {
    if (this.pwReset !== undefined) {
      return html`<comp-sysusersettingspasswordform
        .mode=${`PwReset`}
        .resetId=${this.pwReset.token}
      >
      </comp-sysusersettingspasswordform>`
    }
  }
}
